<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <form>
          <md-card class="edit-profile">
            <md-card-header class="md-card-header-icon">
              <div class="card-icon"><md-icon>group</md-icon></div>
              <h4 class="title">Company Profile</h4>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Company Name</label>
                    <md-input v-model="companyData.company.company_name"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Company Email</label>
                    <md-input v-model="companyData.company.company_email_address" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Company Office Phone Number</label>
                    <md-input v-model="companyData.company.office_phone" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Address</label>
                    <md-input v-model="companyData.company.address_attributes.street_address" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Address Line 2</label>
                    <md-input v-model="companyData.company.address_attributes.address_line_2" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>City</label>
                    <md-input v-model="companyData.company.address_attributes.city" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Locality/State/Province</label>
                    <md-input v-model="companyData.company.address_attributes.state" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Zip Code/Postal Code</label>
                    <md-input v-model="companyData.company.address_attributes.zip_code" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Company Owner</label>
                    <md-input v-model="companyData.company.company_contact" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Company Contact Phone Number</label>
                    <md-input v-model="companyData.company.company_contact_number" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Company Contact Title</label>
                    <md-input v-model="companyData.company.company_contact_title" type="text"></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
              <md-button class="md-success" v-on:click="showDialog">Invite Employee</md-button>
              <md-button v-on:click="updateCompanyData" class="md-info">Update Company Profile</md-button>
            </md-card-actions>
          </md-card>
        </form>
      </div>

      <!-- facility -->
      <md-card class="md-layout-item md-medium-size-100 md-size-100 edit-profile"
        v-if='companyData.company.company_type == "facility"'>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon"><md-icon>book</md-icon></div>
          <h4 class="title">Facilities</h4>
          <md-button class="md-success mt-4" v-on:click="showFacilityDialog">Add facility</md-button>
        </md-card-header>
        <md-card-content>
          <md-table v-model="facilities" table-header-color="green" class="employees">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Address">{{ item.address.street_address }} ; {{ item.address.city }},
                {{ item.address.state }} {{ item.address.zip_code }}</md-table-cell>

              <md-table-cell md-label="Members">
                <md-chip v-for="member in item.members" :key="member.id" class="md-primary">{{ member.name }}</md-chip>
              </md-table-cell>
              <md-table-cell md-label="" class="cell-icon"
                @click.native="deleteFacility(item)"><md-icon>delete_outline</md-icon></md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
      <!-- end facility -->

      <!-- employee -->
      <md-card class="md-layout-item md-medium-size-100 md-size-100 edit-profile">
        <md-card-header class="md-card-header-icon">
          <div class="card-icon"><md-icon>group</md-icon></div>
          <h4 class="title">Employees</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="employees" table-header-color="green" class="employees">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
              <md-table-cell md-label="Phone Number">{{ item.phone_number }}</md-table-cell>
              <md-table-cell md-label="Level" class="cap">{{ item.level }}</md-table-cell>
              <md-table-cell md-label="GPR Access" class="cap">{{ item.gpr_access }}</md-table-cell>
              <md-table-cell md-label="GPR Task Type" class="cap">{{ item.gpr_task_type }}</md-table-cell>
              <md-table-cell md-label="Invite Sent" class="cap">{{ item.invited_at | formatDate }}</md-table-cell>
              <md-table-cell md-label="Invite Accepted?" class="cap">{{ item.invite_accepted }}</md-table-cell>
              <md-table-cell md-label="Change Level" class="cell-button" @click.native="changeLevel(item)">Make
                {{ levelChangeWord(item) }}</md-table-cell>
              <md-table-cell md-label="Edit" class="cell-icon" @click.native="handleEdit(item)"><md-icon
                  class="d-block">edit_outline</md-icon></md-table-cell>
              <md-table-cell md-label="" class="cell-icon"
                @click.native="deleteUser(item)"><md-icon>delete_outline</md-icon></md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
      <!-- end employee -->
      <!-- <tabs :tab-name="['Employees', 'Facilities']">
        <template slot="tab-pane-1">


        </template>

<template slot="tab-pane-2">

        </template>
</tabs> -->

      <div class="dialog-wrapper">
        <md-dialog :md-active.sync="showUserInvite">
          <div class="title-top md-dialog-title">
            <h4>Invite a User</h4>
            <md-icon v-on:click.native="showDialog">close</md-icon>
          </div>
          <UserInvite v-on:closeBox="saveUser" />
        </md-dialog>
      </div>

      <div class="dialog-wrapper">
        <md-dialog :md-active.sync="showFacility">
          <div class="title-top md-dialog-title">
            <h4>Add facility</h4>
            <md-icon v-on:click.native="showFacilityDialog">close</md-icon>
          </div>
          <AddFacility v-on:closeBox="saveFacility" :company="companyData.company.id"
            v-on:childToParent="addFacility" />
        </md-dialog>
      </div>

    </div>
  </div>
</template>

<script>
import UserInvite from "@/pages/Dashboard/Components/UserInvite.vue";
import AddFacility from "@/pages/Dashboard/Components/AddFacility.vue";
import api from "@/api";
import moment from 'moment';
import { Tabs } from "@/components";

export default {
  components: {
    UserInvite,
    AddFacility
  },
  data() {
    return {
      selected: [],
      showUserInvite: false,
      showFacility: false,
      companyData: {
        company: {
          id: '',
          company_name: '',
          office_phone: '',
          company_contact: '',
          company_contact_number: '',
          company_email_address: '',
          company_contact_title: '',
          company_type: 'gpr_contractor',
          address_attributes: {
            street_address: '',
            address_line_2: '',
            city: '',
            state: '',
            zip_code: '',
            country: 'United States'
          }
        },
      },
      employees: [],
      facilities: [],
    }
  },
  methods: {
    showDialog() {
      this.showUserInvite = !this.showUserInvite;
    },
    showFacilityDialog() {
      this.showFacility = !this.showFacility;
    },
    updateCompanyData() {
      api.updateCompanyData(this.companyData.id, this.companyData).then((response) => {
        console.log(response);
        if (response.status == 200) {
          // this.updateMessage = "Your company data has been updated"
          this.notifyVue("Your company data has been updated")
        }
      })
    },
    saveUser(newUser) {
      this.employees.push(newUser);
      this.showDialog();
    },
    saveFacility(newUser) {
      this.facilities.push(newUser);
      this.showFacilityDialog();
    },
    notifyVue(message) {
      this.$notify({
        timeout: 2500,
        message: message,
        icon: "done_all",
        horizontalAlign: "left",
        verticalAlign: "top",
        type: "success"
      });
    },
    levelChangeWord(item, api = false) {
      if (item.level == 'Admin') {
        return "Employee"
      } else if (item.level == 'Employee') {
        if (api) {
          return "owner"
        } else {
          return "Admin"
        }
      }
    },
    changeLevel(item) {
      console.log(item);
      var word_api = this.levelChangeWord(item, true).toLowerCase();
      var word = this.levelChangeWord(item);
      var levelChange = { new_level: word_api }

      api.updateUserLevel(item.id, levelChange).then((response) => {
        console.log(response)
        var index = this.employees.findIndex((u) => u.id == item.id);
        this.employees[index].level = word
        this.notifyVue(`You have updated ${item.name} to ${word}`)
      })
    },
    deleteUser(item) {
      if (confirm(`Are you sure you want to delete ${item.email}?`)) {
        api.deleteUser(item.id).then((response) => {
          var index = this.employees.findIndex((u) => u.id == item.id);
          this.employees.splice(index, 1)
          this.notifyVue(`You have deleted ${item.email}`)
        })
      }
    },
    handleEdit(item) {
      this.$router.push(`/edituser/${item.id}`)
      // Swal.fire({
      //   title: `You want to edit ${item.name}`,
      //   buttonsStyling: false,
      //   confirmButtonClass: "md-button md-info",
      // });
    },
    deleteFacility(item) {
      if (confirm(`Are you sure you want to delete ${item.name}?`)) {
        api.deleteFacility(item.id).then((response) => {
          var index = this.facilities.findIndex((u) => u.id == item.id);
          this.facilities.splice(index, 1)
          this.notifyVue(`You have deleted ${item.name}`)
        })
      }
    },
    addFacility(facility) {
      this.facilities.push(facility)
      console.log('added', facility);
    }

  },
  created() {
    var user = this.$store.state.user;
    if (user) {
      api.getCompanyData(user.id).then((response) => {
        console.log(response);
        this.companyData.company = response.data.company;
        this.employees = response.data.employees;
        this.facilities = response.data.facilities;

        console.log(this.companyData);
        if (response.data.address !== null) {
          this.companyData.company.address_attributes = response.data.address;
        } else {
          this.companyData.company.address_attributes = { street_address: '', address_line_2: '', city: '', state: '', country: '', zip_code: '' }
        }

      })
    }
  },
  filters: {
    formatDate: function (value) {
      var check = moment(value);
      if (check._i !== "N/A") {
        return moment(String(value)).format('MM/DD/YYYY')
      } else {
        return "N/A"
      }
    }
  }
};
</script>
<style lang="scss">
.text-right {
  display: flex;
}

.employees {
  .cap {
    text-transform: capitalize;
  }

  .cell-button {
    font-weight: bold;
    cursor: pointer;
  }

  .cell-icon {
    cursor: pointer;
  }

  .d-block {
    display: block;
  }
}

.tab-pane-1,
.tab-pane-2 {
  width: 100%;
}
</style>
